import React from 'react';
import { isArray } from 'lodash';
import { Combobox, ComboboxOption, ComboboxOptionGroup, ComboboxOptionLabel } from '@fiverr-private/forms';
import { ItemValue } from '@fiverr-private/dropdown';
import { useIdealCandidateContext } from '../../../utils/context';
import { appTranslate } from '../../../../../../i18n';
import { useLocation } from './useLocation';

export const Location = () => {
  const { countriesAndRegions, setCountriesAndRegions } = useIdealCandidateContext();
  const { countriesOptions } = useLocation();
  const listLength = countriesAndRegions.countries.length;

  const getValues = <T extends string>(values: ItemValue[] | ItemValue): T[] =>
    isArray(values) ? values.map((value) => value as T) : [values as T];

  const placeholder = appTranslate('sections.ideal_candidate.location_timezone.location.placeholder');

  return (
    <Combobox
      value={{
        countries: countriesAndRegions.countries || [],
      }}
      onChange={(value) => {
        setCountriesAndRegions({
          countries: value.countries ? getValues(value.countries) : [],
          regions: value.regions ? getValues(value.regions) : [],
        });
      }}
      placeholder={listLength > 0 ? '' : placeholder}
      width="100%"
      maxWidth="550px"
    >
      <ComboboxOptionGroup isMulti name="countries">
        {countriesOptions.map((country) => (
          <ComboboxOption value={country.value} key={country.value}>
            <ComboboxOptionLabel>{country.label}</ComboboxOptionLabel>
          </ComboboxOption>
        ))}
      </ComboboxOptionGroup>
    </Combobox>
  );
};
